<template>
  <div class="content">
    {{ $t(notification.message, notification.replacements) }}
  </div>
</template>
<script setup>
import { defineProps } from 'vue';

defineProps({
  notification: Object
});
</script>
